import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PenTool } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ExperienceBanner = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleWriteStory = () => {
    if (isAuthenticated) {
      navigate('/blogs/write');
      return;
    }

    navigate('/signup', {
      state: {
        from: {
          pathname: '/blogs/write'
        }
      }
    });
  };

  return (
    <section className="px-4 pb-10 sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 rounded-2xl border border-[#ede5fb] bg-white px-5 py-4 shadow-sm sm:px-6">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#8645e9] to-[#ff7b3f] text-white">
            <PenTool className="h-4 w-4" />
          </div>
          <div>
            <p className="text-sm font-semibold text-[#211731]">Have an experience to share?</p>
            <p className="text-xs text-[#6f647d]">Write a blog and inspire students.</p>
          </div>
        </div>

        <button
          type="button"
          onClick={handleWriteStory}
          className="shrink-0 rounded-xl bg-gradient-to-r from-[#7f3df1] to-[#ff7f32] px-4 py-2 text-xs font-semibold text-white shadow-sm transition-transform duration-200 hover:scale-[1.02]"
        >
          {isAuthenticated ? 'Write Story' : 'Sign Up to Write'}
        </button>
      </div>
    </section>
  );
};

export default ExperienceBanner;
